import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faSearch } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";

import UiAction from "./UiAction";
import Navlink from "./Navlink";
import { toggle, selectCollapsed } from "../ui/sidebarCollapseReducer";
import uiManager from '../../config/ui.js';

const Sidebar = (props) => {
  const { editMode, searchQueryVisible } = props;
  const dispatch = useDispatch();
  const collapsed = useSelector(selectCollapsed);
  const toggleSidebar = () => {
    dispatch(toggle());
  };
  const [searchQuery, setSearchQuery] = useState("");

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
  }

  return (
    <nav
      className={`sidebar ${editMode ? 'edit-mode' : ''} ${collapsed ? "collapsed" : ""}`}
    >
      {!editMode && (
        <button
          className={`btn btn-light sidebar-toggle-btn navbar-toggler ${collapsed ? "collapsed" : ""
            }`}
          onClick={toggleSidebar}
        >
          <FontAwesomeIcon icon={collapsed ? faArrowRight : faArrowLeft} />
        </button>
      )}
      <ul className="list-unstyled">
        {!collapsed && searchQueryVisible && (
          <div className="d-flex m-1">
            <span style={{ position: "relative" }} >
              <input
                type="text"
                className="form-control font-size-12" /* s-round-input */
                placeholder="Search"
                onChange={(e) => handleInputChange(e)}
                value={searchQuery}
                style={{paddingRight: '30px'}}
              />
              <span
                className="me-2"
                style={{
                  position: 'absolute',
                  top: "50%",
                  right: "7px",
                  transform: "translateY(-50%)",
                }}
              >
                <FontAwesomeIcon
                  className="icon opacity-50"
                  icon={faSearch}
                />
              </span>
            </span>
          </div>
        )}
        {uiManager.getTopLevelMenuItems().map((menuItem) => (
          <UiAction key={menuItem.uiAction.actionName} uiAction={menuItem.uiAction} editMode={editMode}>
            <Navlink
              menuItem={menuItem}
              editMode={editMode}
              editModePermissions={props.editModePermissions}
              setEditModePermissions={props.setEditModePermissions}
              editModeSetSelectedUiAction={props.editModeSetSelectedUiAction}
              editModeSelectedUiActionBreadcrumb={props.editModeSelectedUiActionBreadcrumb}
              editModeSetSelectedUiActionBreadcrumb={props.editModeSetSelectedUiActionBreadcrumb}
              searchQuery={searchQuery}
            />
          </UiAction>
        ))
        }
      </ul>
    </nav>
  );
};

export default Sidebar;
